import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Button, {
  ButtonType,
  ButtonSize
} from '@/shared/components/core-ui/LegacyButton/button.component';
import { PUBLIC_PATH, HOST_NAME, APP_ROUTES } from '@/shared/config/routes-config';
import { RouteConfig } from '@/shared/interfaces/routes-config.interface';
import { cleanupUserData } from '@/shared/services/helpers/auth-helper/auth-helper.service';

import styles from './unauthorized.module.scss';

interface UnauthorizedProps {
  config?: { hideHomeButton: boolean };
}

/**
 * Unauthorized functional component
 */
export const Unauthorized: React.FC<UnauthorizedProps> = ({ config }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className={styles['unauthorized']}>
      <h1 className={styles['unauthorized__title']}>You're not authorized to view this page</h1>
      {!config || (config && !config.hideHomeButton) ? (
        <div className={styles['unauthorized__action-wrapper']}>
          <div className={styles['unauthorized__action-button']}>
            <a href={`${PUBLIC_PATH}`} rel="noopener noreferrer">
              GET BACK TO HOMEPAGE
            </a>
          </div>
          <Button
            onClick={() => {
              cleanupUserData();
              navigate((APP_ROUTES.AUTH_MODULE.CHILDREN as RouteConfig).LOGIN.FULL_PATH);
            }}
            tracking={{
              event: 'navigation_clicked',
              target: 'home',
              location: 'header'
            }}
            type={ButtonType.primaryInverted}
            size={ButtonSize.large}
          >
            {t('AUTH_MODULE.UNAUTHORIZED_CONTAINER.SWITCH_ACCOUNT')}
          </Button>
        </div>
      ) : null}
    </div>
  );
};
